import { card } from '../common'
import { black, lightGrey, mediumGrey } from '../const/colors'
import { defaultBorderRadius } from '../const/common'
import { phonesDown } from '../const/breakpoints'

export function btnIconReset() {
  return {
    border: 'none',
    background: 'none',
    padding: '5px',

    '& .icon': {
      marginLeft: 0
    }
  }
}

export function placeholderColor(color) {
  return {
    '&::-webkit-input-placeholder': {
      color,
      opacity: 1
    },
    ':-moz-placeholder': {
      /* Mozilla Firefox 4 to 18 */ color,
      opacity: 1
    },
    '::-moz-placeholder': {
      /* Mozilla Firefox 19+ */ color,
      opacity: 1
    },
    ':-ms-input-placeholder': {
      /* Internet Explorer 10-11 */ color,
      opacity: 1
    },
    '::-ms-input-placeholder': {
      /* Microsoft Edge */ color,
      opacity: 1
    },

    '::placeholder': {
      /* Most modern browsers support this now. */ color,
      opacity: 1
    }
  }
}

export function narrowContainer(width) {
  return {
    position: 'relative',
    maxWidth: width ? width : '880px',
    margin: `25px auto`
  }
}

export function cardWithBorder(borderColor, theme) {
  return {
    extend: card,

    display: 'flex',
    alignItems: 'center',
    padding: '8px 11px 8px 15px',
    position: 'relative',
    marginBottom: 8,

    '&:before': {
      content: '""',
      position: 'absolute',
      width: 5,
      height: '100%',
      background: borderColor || theme.brandPrimary,
      left: 0,
      top: 0,
      borderBottomLeftRadius: 3,
      borderTopLeftRadius: 3
    }
  }
}

export const input = theme => ({
  padding: '11px 10px 11px 13px',
  color: black,
  width: '100%',
  appearance: 'none',
  lineHeight: 1.2,
  border: {
    width: 1,
    style: 'solid'
  },
  borderColor: lightGrey,
  borderRadius: defaultBorderRadius,
  outline: 'none',
  ...placeholderColor(mediumGrey),
  '&:active, &:focus': {
    borderColor: theme.brandPrimary,

    '& ~ $symbol': {
      opacity: 1
    }
  },

  '&[type="number"]': {
    appearance: 'textfield',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      margin: 0,
      appearance: 'none'
    }
  },

  '&:-webkit-autofill': {
    '& ~ $symbol': {
      opacity: 1
    }
  },

  [`@media screen and (${phonesDown})`]: {
    fontSize: 12,
    padding: '9px 6px 9px 9px'
  }
})

export function smartWordWrapMixin() {
  return {
    /* 1) allow normal wrapping at spaces */
    whiteSpace: 'normal',
    /* 2) avoid breaking inside “real” words (i.e. only break at spaces/underscores) */
    wordsBreak: 'keep-all',
    /* 3) if a single token is longer than its container
     e.g. 'Eukanuba_Crufts_Partner_Partner'
     break it anywhere
     so it doesn’t overflow or get clipped */
    overflowWrap: 'anywhere',
    /* legacy fallback for older browsers */
    wordWrap: 'break-word'
  }
}
